import React from "react";

function Gallery() {
  return (
  <div className="gallery">

    <figure className="gallery__item gallery__item--1">
      <img src="./img/blue-mountain.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--2">
      <img src="./img/dog.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--3">
      <img src="./img/dude.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--4">
      <img src="./img/feet.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--5">
      <img src="./img/logo-main.png" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--6">
      <img src="./img/standing-girl.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--7">
      <img src="./img/moon-kiss.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--8">
      <img src="./img/nightlight.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--9">
      <img src="./img/schoolie-2.png" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--10">
      <img src="./img/sleek.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--11">
      <img src="./img/snowy.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--12">
      <img src="./img/socks.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--13">
     <img src="./img/sunrise-breakfast.jpg" alt="van shot" className="gallery__img" />
    </figure>

    <figure className="gallery__item gallery__item--14">
    <img src="./img/tiny-desk.jpg" alt="van shot" className="gallery__img" />
    </figure>
    
  </div>
  );
}

export default Gallery;